import { useMutation } from '@tanstack/react-query';
import { IInvoiceFullObject } from '../../Interfaces/IInvoice';
import { customFetcher } from '../useFetch';
import { IDocument } from '../../Interfaces/IDocument';

export const useCheckDocumentForInvoice = () => {
  const {
    mutateAsync: checkDocumentForInvoice,
    isPending: isPendingCheckDocumentForInvoice,
  } = useMutation<IInvoiceFullObject[], Error, IDocument[]>({
    mutationFn: (documentArray: IDocument[]) =>
      customFetcher({
        endpoint: '/document/check_invoice',
        method: 'POST',
        body: documentArray,
      }),
  });

  return {
    checkDocumentForInvoice,
    isPendingCheckDocumentForInvoice,
  };
};
